import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { IconSpriteComponent } from './icons/icon-sprite.component';

/**
 * App-wide singletons: import exactly once, from AppModule. Anything reusable across
 * multiple feature modules (like the page shell) belongs in SharedModule instead —
 * lazy-loaded feature modules get their own injector, and re-importing a module guarded
 * like this one from more than one place trips the check below.
 */
@NgModule({
  declarations: [IconSpriteComponent],
  imports: [CommonModule],
  exports: [IconSpriteComponent],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it only in AppModule.');
    }
  }
}
